import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getPagesRequest } from 'store/thunks/pagesThunks'
import { getGlobalAnalyticsRequest } from 'store/thunks/analyticsThunks'
import {
  ButtonLink,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  FlexItem
} from 'components/Library'
import TotalPages from './Charts/Global/TotalPages'
import AvgTime from './Charts/Global/AvgTime'
import TotalViews from './Charts/Global/TotalViews'
import UniqueUsers from './Charts/Global/UniqueUsers'
import ViewsPerPage from './Charts/Global/ViewsPerPage'
import ViewsPerCity from './Charts/Global/ViewsPerCity'
import NewUsers from './Charts/Global/NewUsers'
import RecentPages from './Charts/Global/RecentPages'
import styled from 'styled-components'

const StyledFlexItem = styled(FlexItem)`
  padding: 0;

  @media (min-width: 768px) {
    flex-basis: calc(50% - 1rem);
  }

  @media (min-width: 1034px) {
    flex-basis: calc(25% - 1.5rem);
  }
`

const GlobalAnalytics = () => {
  const dispatch = useDispatch()

  /**
   * Hook useEffect para obtener todas los paginas usando el thunk {@link getPagesRequest}
   * y cargar las analíticas globales con el thunk {@link getGlobalAnalyticsRequest}
   */
  useEffect(() => {
    dispatch(getPagesRequest())
    dispatch(getGlobalAnalyticsRequest())
  }, [dispatch])

  return (
    <Card style={{ margin: '2rem auto', width: '95%' }}>
      <CardHeader color="primary">Estadísticas globales</CardHeader>
      <CardBody>
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          style={{
            gap: '2rem 0'
          }}
        >
          {/* Paginas totales */}
          <StyledFlexItem>
            <TotalPages />
          </StyledFlexItem>
          {/* Visitas totales */}
          <StyledFlexItem>
            <TotalViews />
          </StyledFlexItem>
          {/* Usuarios unicos */}
          <StyledFlexItem>
            <UniqueUsers />
          </StyledFlexItem>
          {/* Tiempo promedio */}
          <StyledFlexItem>
            <AvgTime />
          </StyledFlexItem>
          {/* Accesos por página */}
          <FlexItem
            style={{
              padding: 0
            }}
            flexBasis={50}
            justifyContent="space-between"
          >
            <FlexItem flexDirection="column" style={{ gridGap: '2rem', padding: 0 }}>
              <ViewsPerPage />
              <RecentPages />
            </FlexItem>
          </FlexItem>

          {/* Visitas por ciudades y Paginas totales */}
          <FlexItem
            flexBasis={50}
            style={{
              padding: 0,
              alignSelf: 'flex-start'
            }}
          >
            <ViewsPerCity />
          </FlexItem>

          {/* Nuevos usuarios al mes */}
          <FlexItem
            style={{
              padding: 0
            }}
          >
            <NewUsers />
          </FlexItem>
        </Flex>
      </CardBody>
      <CardFooter
        style={{
          borderTop: 0,
          paddingTop: 0
        }}
      >
        <ButtonLink
          borderradius={2}
          color="dark"
          to="/pages"
          text="Regresar"
          style={{
            display: 'block',
            width: 'fit-content'
          }}
        />
        {/* <Button borderradius={2} color="primary" text="Descargar PDF"></Button> */}
      </CardFooter>
    </Card>
  )
}

export default GlobalAnalytics
